// Generated by tools/build/i18n_bundle.py — do not edit by hand.
// Point the PWA manifest <link> at the user's locale before the browser reads it.
(function () {
  var SHIPPED = ["nl", "de", "es", "fr", "pt", "it", "hu", "ru", "pl", "id", "tr", "ca", "uk", "el", "cs", "sv", "nb", "ro", "fi", "th", "vi", "bg", "da", "ja", "ko", "zh"];
  try {
    var l = localStorage.getItem("ghd_ui_lang") || sessionStorage.getItem("ghd_signed_out_auth_locale");
    if (l && SHIPPED.indexOf(l) !== -1) {
      var link = document.querySelector('link[rel="manifest"]');
      if (link) link.href = "/manifest." + l + ".json";
    }
  } catch (e) {}
})();

// Preload the locale bundle the loader will fetch, and the chat's chunks when
// this load opens the chat. Locale resolution must match i18n/bundles-loader.js.
(function () {
  var SHIPPED = ["en", "nl", "de", "es", "fr", "pt", "it", "hu", "ru", "pl", "id", "tr", "ca", "uk", "el", "cs", "sv", "nb", "ro", "fi", "th", "vi", "bg", "da", "ja", "ko", "zh"];
  function pick(code) {
    if (!code) return null;
    var primary = String(code).replace("_", "-").split("-")[0].toLowerCase();
    return SHIPPED.indexOf(primary) !== -1 ? primary : null;
  }
  // Set by i18n/arrival-locale.js from the ?lang= a localized marketing
  // page named on the link over here. Ahead of storage because on a device
  // that has none it is the only thing carrying the visitor's language.
  var arrival = typeof window !== "undefined" ? window.__GHD_ARRIVAL_LANG__ : null;
  var stored = null;
  var signedOutAuth = null;
  try {
    stored = localStorage.getItem("ghd_ui_lang");
    signedOutAuth = sessionStorage.getItem("ghd_signed_out_auth_locale");
  } catch (e) {}
  var lang =
    pick(arrival) ||
    pick(stored) ||
    pick(signedOutAuth) ||
    pick(typeof navigator !== "undefined" ? navigator.language : null) ||
    "en";
  function preload(href, as) {
    var link = document.createElement("link");
    link.rel = "preload";
    link.as = as;
    link.href = href;
    document.head.appendChild(link);
  }
  try {
    preload(new URL("bundles." + lang + ".js", document.currentScript.src).href, "script");
  } catch (e) {}
  var CHAT_PRELOADS = ["/v/__GHD_VERSION__/css/route-auth-chat-onboarding-people.css", "/v/__GHD_VERSION__/css/route-chat.css", "/v/__GHD_VERSION__/css/route-chat-compare-cycles-groups-people-transits.css", "/v/__GHD_VERSION__/css/route-chat-compare-groups-people.css", "/v/__GHD_VERSION__/css/route-chat-compare-people-transits.css", "/v/__GHD_VERSION__/css/route-chat-cycles-settings-transits.css", "/v/__GHD_VERSION__/css/route-chat-people.css", "/v/__GHD_VERSION__/css/route-chat-transits.css", "/v/__GHD_VERSION__/js/route-advanced-chat.js", "/v/__GHD_VERSION__/js/route-advanced-chat-compare-cycles-groups-kb-people-transits.js", "/v/__GHD_VERSION__/js/route-auth-chat-compare-cycles-groups-onboarding-people-settings-transits.js", "/v/__GHD_VERSION__/js/route-auth-chat-onboarding-people.js", "/v/__GHD_VERSION__/js/route-chat.js", "/v/__GHD_VERSION__/js/route-chat-compare-cycles-groups-people-settings-stage-transits.js", "/v/__GHD_VERSION__/js/route-chat-compare-cycles-groups-people-transits.js", "/v/__GHD_VERSION__/js/route-chat-compare-cycles-groups-transits.js", "/v/__GHD_VERSION__/js/route-chat-compare-groups-people-transits.js", "/v/__GHD_VERSION__/js/route-chat-compare-pdf.js", "/v/__GHD_VERSION__/js/route-chat-compare-pdf-people.js", "/v/__GHD_VERSION__/js/route-chat-compare-pdf-transits.js", "/v/__GHD_VERSION__/js/route-chat-compare-people-transits.js", "/v/__GHD_VERSION__/js/route-chat-cycles-playbilling-settings-transits.js", "/v/__GHD_VERSION__/js/route-chat-cycles-settings-transits.js", "/v/__GHD_VERSION__/js/route-chat-people.js"];
  try {
    var rest = location.pathname.slice(new URL(document.baseURI).pathname.length).replace(/\/$/, "");
    var chat = rest === "" || rest === "chat" || rest === "chats";
    var signedIn = false;
    for (var i = 0; i < localStorage.length; i++) {
      if (/^sb-.+-auth-token$/.test(localStorage.key(i))) signedIn = true;
    }
    if (chat && signedIn) {
      CHAT_PRELOADS.forEach(function (href) {
        preload(href, /\.css$/.test(href) ? "style" : "script");
      });
    }
  } catch (e) {}
})();
